import React from 'react';
import { useController } from 'react-hook-form';
import { Form, PhoneInput } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import { FieldErrorMessage } from '../FieldErrorMessage';

export const FormPhoneInput = ({ name, label, required = false, ...rest }) => {
    const {
        field: { value, onChange },
        fieldState: { error }
    } = useController({
        name
    });

    return (
        <Form.Field>
            <Form.Label for={name} label={label} required={required} />
            <PhoneInput errors={error} useNew id={name} value={value} onChange={onChange} {...rest} />
            <FieldErrorMessage error={error} />
        </Form.Field>
    );
};

FormPhoneInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool
};
